<template>
  <div class="task-children">
    <div class="task-children__wrap" v-for="task in children" :key="task.id">
      <div class="task-children__inner">
        <span class="task-children__button" v-if="task.child_count !== 0" @click.stop="toggleChildren(task.id)">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <transition name="scaleCenter">
              <path d="M10.3462 0L10.3462 21.5542" stroke="#95A4C0" stroke-width="2" v-if="!task.children_active"/>
            </transition>
            <path d="M21.5542 11.208L9.29832e-06 11.208" stroke="#95A4C0" stroke-width="2"/>
          </svg>
        </span>
        <span class="task-children__placeholder" v-else></span>
        <div class="task-children__task-info">
          <router-link :to="`/task/info/${task.id}`" class="link task-children__task-name task-children__task-info__item">{{ task.name }}</router-link>
          <div class="task-children__task-info__item">{{ task.column.name }}</div>
        </div>
      </div>
      <transition name="fade">
        <TaskChildrenList v-if="task.children && task.children.length !== 0"
                          :children="task.children ? task.children : []"
        />
      </transition>
    </div>
  </div>
</template>

<script>

export default {
  name: 'task-children-list',
  components: {
    TaskChildrenList: () => import('./TaskChildrenList.vue')
  },
  props: {
    children: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  data () {
    return {}
  },
  methods: {
    toggleChildren (taskId) {
      this.$store.dispatch('toggleTaskInfoChildTaskChildren', taskId)
    },
    getColumnName (id) {
      return this.$store.getters.getColumnById(id)
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.task-children {
  overflow: hidden;

  &__wrap {
    padding: 8px 10px 8px 20px;

    .task-children__wrap {
      padding: 0;
      margin-bottom: 8px;
    }
  }

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 8px;

    &:only-child {
      margin-bottom: 0;
    }
  }

  &__button {
    margin-right: 20px;
    cursor: pointer;
    user-select: none;

    @media screen and (max-width: $tablet_start) {
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  // заглушка для сохранения выравнивания, если нет плюсика
  // ширина и правый отступ должны быть равны ширине &__button
  &__placeholder {
    display: inline-block;
    width: 22px;
    margin-right: 20px;
  }

  &__task-info {
    display: flex;
    flex-flow: row nowrap;

    &__item {
      padding-right: 8px;
      margin-right: 8px;
      border-right: 1px solid $border_color;

      &:last-child {
        border-right: none;
      }
    }
  }

  &__task-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &::after {
      display: none;
    }
  }

  .task-children {
    margin-left: 10px;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}
</style>
